module.exports = __webpack_public_path__ + "static/img/HR.02a24786.jpg";